module.exports = __webpack_public_path__ + "static/media/apng_drops.733758b2.png";